import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../axiosComponent";
import { serviceUrls } from "../constant";

// Utility function for common hostel data preparation
const prepareHostelData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

// Hostel Management Services
export const getHostelsList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel/list",
    params: createQueryParams(prepareHostelData(data)),
  });
};

export const getHostelDetails = async (entityId) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel",
    params: createQueryParams({ entityId }),
  });
};

export const addHostel = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel",
    data: prepareHostelData(data),
  });
};

export const updateHostel = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel",
    data: prepareHostelData(data),
  });
};

export const deleteHostel = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel",
    params: createQueryParams({ entityId }),
  });
};

export const updateHostelStatus = async (data) => {
  return await patch({
    url: serviceUrls.HOSTEL_SERVICE + "/hostel",
    params: createQueryParams(data),
  });
};

// Hostel Facilities Services
export const getHostelFacilities = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/facilities/list",
    params: createQueryParams(prepareHostelData(data)),
  });
};

export const addHostelFacility = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/facilities",
    data: prepareHostelData(data),
  });
};

export const updateHostelFacility = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/facilities",
    data: prepareHostelData(data),
  });
};

export const deleteHostelFacility = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/facilities",
    params: createQueryParams({ entityId }),
  });
};

// Hostel Food Menu Services
export const getHostelMenuList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/list",
    params: createQueryParams(prepareHostelData(data)),
  });
};

export const getDefaultHostelFoodMenu = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/list",
    params: createQueryParams(prepareHostelData({ ...data, isSpecial: "N" })),
  });
};

export const getDynamicHostelFoodMenu = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu/list",
    params: createQueryParams(prepareHostelData({ ...data, isSpecial: "Y" })),
  });
};

export const addHostelFoodMenu = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu",
    data: prepareHostelData(data),
  });
};

export const updateHostelFoodMenu = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu",
    data: prepareHostelData(data),
  });
};

export const deleteHostelFoodMenu = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/food/menu",
    params: createQueryParams({ entityId }),
  });
};

// Hostel Users Services
export const getHostelUsersList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/user/list",
    params: createQueryParams(prepareHostelData(data)),
  });
};

// Hostel Applications Services
export const getHostelApplicationList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/application/list",
    params: createQueryParams(prepareHostelData({ ...data, status: "PENDING" })),
  });
};

export const getRejectedHostelApplicationList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/application/list",
    params: createQueryParams(prepareHostelData({ ...data, status: "REJECTED" })),
  });
};

export const submitHostelApplication = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/application",
    data: prepareHostelData(data),
  });
};

export const acceptHostelApplication = async (entityId, roomId) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/application/:entityId/:roomId",
    pathParams: { entityId, roomId },
  });
};

export const rejectHostelApplication = async (entityId) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/application/:entityId",
    pathParams: { entityId },
  });
};

// Hostel Complaints Services
export const getHostelComplainsList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/complains/list",
    params: createQueryParams(prepareHostelData(data)),
  });
};

export const addHostelComplaint = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/complains",
    data: prepareHostelData(data),
  });
};

export const updateHostelComplaint = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/complains",
    data: prepareHostelData(data),
  });
};

export const deleteHostelComplaint = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/complains",
    params: createQueryParams({ entityId }),
  });
};

// Hostel Guest Services
export const getHostelGuestList = async (data) => {
  return await get({
    url: serviceUrls.HOSTEL_SERVICE + "/guest/list",
    params: createQueryParams(prepareHostelData(data)),
  });
};

export const addHostelGuest = async (data) => {
  return await post({
    url: serviceUrls.HOSTEL_SERVICE + "/guest",
    data: prepareHostelData(data),
  });
};

export const updateHostelGuest = async (data) => {
  return await put({
    url: serviceUrls.HOSTEL_SERVICE + "/guest",
    data: prepareHostelData(data),
  });
};

export const deleteHostelGuest = async (entityId) => {
  return await del({
    url: serviceUrls.HOSTEL_SERVICE + "/guest",
    params: createQueryParams({ entityId }),
  });
};

export const updateHostelGuestStatus = async (data) => {
  return await patch({
    url: serviceUrls.HOSTEL_SERVICE + "/guest",
    params: createQueryParams(data),
  });
};
